import _JSON$stringify from "@babel/runtime-corejs2/core-js/json/stringify";
import CryptoJS from 'crypto-js';
var key = CryptoJS.enc.Utf8.parse('47p1d67o4057c79y41e81bf67c1a4j69'); //十六位十六进制数作为密钥

var iv = CryptoJS.enc.Utf8.parse(''); //十六位十六进制数作为密钥偏移量

/**
 * 加密
 * @param {*} data 上报数据
 */

var getEncrypt = function getEncrypt(data) {
  if (typeof data !== 'string') {
    data = _JSON$stringify(data);
  }

  var srcs = CryptoJS.enc.Utf8.parse(data);
  var encrypted = CryptoJS.AES.encrypt(srcs, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  });
  return encrypted.toString();
}; //解密方法


var getDecrypt = function getDecrypt(word) {
  var encrypted = CryptoJS.AES.decrypt(word, key, {
    iv: iv,
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  });
  return CryptoJS.enc.Utf8.stringify(encrypted).toString();
};

function byteArrayToWordArray(ba) {
  var wa = [],
      i;

  for (i = 0; i < ba.length; i++) {
    wa[i / 4 | 0] |= ba[i] << 24 - 8 * i;
  }

  return CryptoJS.lib.WordArray.create(wa, ba.length);
}

function wordToByteArray(word, length) {
  var ba = [],
      i,
      xFF = 0xff;
  if (length > 0) ba.push(word >>> 24);
  if (length > 1) ba.push(word >>> 16 & xFF);
  if (length > 2) ba.push(word >>> 8 & xFF);
  if (length > 3) ba.push(word & xFF);
  return ba;
}

function wordArrayToByteArray(wordArray, length) {
  if (wordArray.hasOwnProperty('sigBytes') && wordArray.hasOwnProperty('words')) {
    length = wordArray.sigBytes;
    wordArray = wordArray.words;
  }

  var result = [],
      bytes,
      i = 0;

  while (length > 0) {
    bytes = wordToByteArray(wordArray[i], Math.min(4, length));
    length -= bytes.length;
    result.push(bytes);
    i++;
  }

  return [].concat.apply([], result);
}

export default {
  getEncrypt: getEncrypt,
  getDecrypt: getDecrypt
};